import { useCallback } from "react";

import { defineMessages, useIntl } from "react-intl";

import { showModal } from "@mapmycustomers/ui";

const messages = defineMessages({
  cancel: {
    id: "integrations.selectDynamicInstanceModal.confirmation.cancel",
    defaultMessage: "Cancel",
    description: "cancel text select dynamic instance confirmation modal",
  },
  content: {
    id: "integrations.selectDynamicInstanceModal.confirmation.content",
    defaultMessage: "Please note that by closing this pop-up will cancel this integration setup",
    description: "content text select dynamic instance confirmation modal",
  },
  ok: {
    id: "integrations.selectDynamicInstanceModal.confirmation.ok",
    defaultMessage: "Confirm",
    description: "Ok text select dynamic instance confirmation modal",
  },
  title: {
    id: "integrations.selectDynamicInstanceModal.confirmation.title",
    defaultMessage: "Confirmation",
    description: "Title select dynamic instance confirmation modal",
  },
});

const useCancelIntegrationModalConfirm = (onConfirm: () => void): [() => void] => {
  const intl = useIntl();

  const confirm = useCallback(
    () =>
      showModal({
        cancelButtonProps: {
          type: "text",
        },
        cancelText: intl.formatMessage(messages.cancel),
        content: intl.formatMessage(messages.content),
        okText: intl.formatMessage(messages.ok),
        onOk: () => onConfirm(),
        title: intl.formatMessage(messages.title),
        type: "confirm",
      }),
    [intl, onConfirm]
  );

  return [confirm];
};

export default useCancelIntegrationModalConfirm;
